<template>
  <div
    v-if="items.length"
    class="side-panel-section"
    :data-qa="`${dataQaPrefix}-payload`"
  >
    <div
      class="side-panel-section-title"
      :data-qa="`${dataQaPrefix}-payload-title`"
    >
      {{ $t('CampaignForm_Preview_Push_PayloadTitle') }}
    </div>
    <key-value-viewer
      :items="items"
      :data-qa="`${dataQaPrefix}-payload-viewer`"
    />
  </div>
</template>

<script>
import KeyValueViewer from '@/modules/campaign-manage/components/content/channels/KeyValueViewer.vue'

export default {
  name: 'PreviewPayload',
  components: { KeyValueViewer },
  props: {
    items: {
      type: Array,
      required: true
    },
    dataQaPrefix: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped>
.side-panel-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #303133;
  margin-top: 0;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/PreviewPayload.vue